import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import OnboardingContext from '../../providers/Onboarding/Onboarding.context';
import DataRoomDocumentsRouter from '../../components/DataRoomDocumentsRouter';
import HelmetWrapper from 'components/HelmetWrapper';
import GroupChatBuySideCard from './components/GroupChatBuySideCard';

import './Documents.styles.scss';

type DocumentsProps = {
  className?: string;
};

const Documents: React.FC<DocumentsProps> = (props) => {
  const { className } = props;

  const {
    dataRoom: { name },
  } = useContext(DataRoomContext);
  const { contentCard } = useContext(OnboardingContext);

  const classes = classNames('dr-documents', 'page', className);

  const { t } = useTranslation();
  return (
    <div className={classes}>
      <HelmetWrapper title={`${t('files')} - ${name}`} />
      <h2>{t('files')}</h2>
      {contentCard}
      <GroupChatBuySideCard />
      <DataRoomDocumentsRouter />
    </div>
  );
};

export default Documents;
